module.exports = __webpack_public_path__ + "static/img/17.728b83e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/17.jpg
// module id = yOyn
// module chunks = 5